/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_TitleInputs */

const fr_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos de Bus Tracker`)
};

const en_about_title = /** @type {(inputs: About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Bus Tracker`)
};

/**
* | output |
* | --- |
* | "About Bus Tracker" |
*
* @param {About_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const about_title = /** @type {((inputs?: About_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_about_title(inputs)
	return en_about_title(inputs)
});